import { mergeProps } from 'solid-js';
import { ImageComponent } from './image-component';
import { ImageWordpress } from '../../types/shared';
import { useLocation } from '@solidjs/router';

type WrappedImageProps = {
    image: ImageWordpress;
    altText?: string;
    useFocusPoint?: boolean;
    roundCorners?: 'none' | 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl' | 'full';
    aspectRatio?: 'original' | 'wide' | 'portrait' | 'square' | 'newsListImage' | 'clients';
    renderWidth?: string;
    renderHeight?: string;
    width?: number | string;
    height?: number | string;
    classes?: string;
    topRounding?: boolean;
    noRoundCornersRightSide?: boolean;
};

const defaultProps = {
    renderWidth: '100%',
    renderHeight: 'auto',
};

const Svg = (componentProps: WrappedImageProps) => {
    const alt = componentProps.altText ?? componentProps.image.altText ?? '';

    return (
        <img
            src={componentProps.image.url}
            alt={alt}
            title={alt || undefined}
        />
    );
};

export const WrappedImage = (componentProps: WrappedImageProps) => {
    const props = mergeProps(defaultProps, componentProps);
    const location = useLocation();

    if (!componentProps.image || !componentProps.image.url) {
        console.warn('Image URL missing or null:', componentProps.image, { path: location?.pathname, search: location?.search, hash: location?.hash, query: location?.query });
        return null;
    }
    if (componentProps.image.url.match(/\.svg$/)) {
        return (<Svg {...props} />);
    }

    return (
        <ImageComponent
            src={props.image.url}
            altText={props.altText ? props.altText : props.image.altText}
            ratio={props.image.ratio}
            focus={props.useFocusPoint && props.image.focus ? props.image.focus : undefined}
            roundCorners={props.roundCorners}
            aspectRatio={props.aspectRatio}
            renderWidth={props.renderWidth}
            renderHeight={props.renderHeight}
            width={props.width ? props.width : props.image.width}
            height={props.height ? props.height : props.image.height}
            classes={props.classes}
            topRounding={props.topRounding}
            noRoundCornersRightSide={props.noRoundCornersRightSide}
        />
    );
};
